<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/aZgNYu/tc-custom/9781504033053.jpg?1729034189800" alt="This image is the cover for the book Clifford's Blues"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Clifford's Blues
      </h1>
      <p class="bookDescription body article font2">
        <b>A black musician arrested by Nazis in 1930s Germany endures the horrors of the Dachau death camp in this harrowing novel based on historical fact</b><br/><br/> A self-proclaimed “gay negro” from New Orleans, Clifford Pepperidge made his name in the smoky nightclubs of Harlem in the 1920s, playing piano alongside Bessie Smith, Duke Ellington, and other jazz greats. A decade later, he thrills crowds nightly in the cabarets of Weimar Berlin. But dark days are on the horizon as the Nazi Party rises to power.<br/>  <br/> Arrested by Hitler’s Gestapo during a roundup of homosexuals, Clifford finds himself placed in “protective custody” and transported to a concentration camp. Stripped of his dignity and his identity, and plunged into a nightmare of forced labor, starvation, and abuse, he seeks escape in his music. When a camp SS officer and jazz aficionado recognizes Clifford, the gentle musician learns just how far a desperate man will go in order to survive.<br/>  <br/> Shining a light on a little-known aspect of the Holocaust, <i>Clifford’s Blues </i>is a disturbing portrait of a dark era in world history and a poignant celebration of the resilience of the human spirit and the power of music.<br/>  
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        John A. Williams
      </h2>
      
      <p class="authorDescription body article">John A. Williams (1925&ndash;2015) was born near Jackson, Mississippi, and raised in Syracuse, New York. The author of more than twenty works of fiction and nonfiction, including the groundbreaking and critically&#160;acclaimed novels <I>The Man Who Cried I Am </I>and <I>Captain Blackman</I>, he has been heralded by the critic James L. de Jongh as &ldquo;arguably the finest Afro-American novelist of his generation.&rdquo; A contributor to the <I>Chicago Defender</I>, the <I>New York Times</I>, and the <I>Los Angeles Times</I>, among many other publications, Williams edited the periodic anthology <I>Amistad</I> and served as the African correspondent for <I>Newsweek </I>and the European correspondent for <I>Ebony </I>and <I>Jet</I>. A longtime professor of English and journalism, Williams retired from Rutgers University as the Paul Robeson Distinguished Professor of English in 1994. His numerous honors include two American Book Awards, the Syracuse University Centennial Medal for Outstanding Achievement, and the National Institute of Arts and Letters Award.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?46c271bb